export enum ENotificationTargetKind {
  Job = "job",
  Quote = "quote",
  Invoice = "invoice",
  AdminInvitation = "adminInvitation",
  ManageAdmins = "manageAdmins",
}
